import { find, assign, get } from 'lodash';
import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchUsers: ['query'],
    fetchUsersSuccess: ['users', 'pagination'],
    fetchUsersFailure: ['error'],

    fetchFlatUsers: ['query', 'callback'],
    fetchFlatUsersSuccess: ['items'],
    fetchFlatUsersFailure: ['error'],

    createUser: ['role_id', 'user', 'query'],
    createUserSuccess: ['user'],
    createUserFailure: ['error'],

    fetchUser: ['user_id', 'query'],
    fetchUserSuccess: ['user'],
    fetchUserFailure: ['error'],

    updateUser: ['user_id', 'user', 'query'],
    updateUserSuccess: ['user'],
    updateUserFailure: ['error'],

    deleteUser: ['user_id', 'query'],
    deleteUserSuccess: null,
    deleteUserFailure: ['error'],

    fetchRoles: ['query'],
    fetchRolesSuccess: ['roles'],
    fetchRolesFailure: ['error'],

    fetchProfile: ['query'],
    fetchProfileSuccess: ['user'],
    fetchProfileFailure: ['error'],

    updateProfile: ['user', 'query'],
    updateProfileSuccess: ['user'],
    updateProfileFailure: ['error'],
});


export const UserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    users: [],
    roles: [],
    flat_users: [],
    user: null,
    pagination: null,
    updateDeleteSuccess: null,
    userCreated: null,
    deletedUser: null,

    lastSyncDt: null,
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch users actions
    [Types.FETCH_USERS]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.FETCH_USERS_SUCCESS]: (state, {users, pagination}) => {
        return {
            ...state,
            users,
            pagination,
            loading: false,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_USERS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Fetch flat users
    [Types.FETCH_FLAT_USERS]: (state) => {
        console.log('FETCH_FLAT_USERS')
        return {
            ...state,
            loading: true,
            error: null,
            flat_users: [],
        };
    },

    [Types.FETCH_FLAT_USERS_SUCCESS]: (state, {items, pagination}) => {
        return {
            ...state,
            error: null,
            flat_users: items,
            loading: false,
        };
    },

    [Types.FETCH_FLAT_USERS_FAILURE]: (state, {error}) => {
        return {
            ...state,
            error,
            loading: false,
            flat_users: [],
        };
    },

    // Create an user
    [Types.CREATE_USER]: (state, action) => {
        return {
            ...state,
            loading : true,
            error: null,
            user: null,
            updateDeleteSuccess: null,
            userCreated: null,
        };
    },

    [Types.CREATE_USER_SUCCESS]: (state, {user}) => {
        return {
            ...state,
            loading: false,
            //user,
            error: null,
            updateDeleteSuccess: true,
            userCreated: user,
        };
    },

    [Types.CREATE_USER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            user: null,
            updateDeleteSuccess: false,
            userCreated: null,
        };
    },

    // Fetch a single user
    [Types.FETCH_USER]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            user: null,
            userToEdit: null,
        };
    },

    [Types.FETCH_USER_SUCCESS]: (state, {user}) => {
        return {
            ...state,
            loading: false,
            error: null,
            user,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.FETCH_USER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            user: null,
        };
    },

    // Update an user
    [Types.UPDATE_USER]: (state, action) => {
        return {
            ...state,
            loading : true,
            error: null,
            updateDeleteSuccess: null,
            userCreated: null,
        };
    },

    [Types.UPDATE_USER_SUCCESS]: (state, {user}) => {
        return {
            ...state,
            loading: false,
            user,
            error: null,
            updateDeleteSuccess: true,
            userCreated: user,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.UPDATE_USER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            user: null,
            updateDeleteSuccess: false,
            userCreated: null,
        };
    },

    // Delete an existing user
    [Types.DELETE_USER]: (state, { uuid }) => {
        return {
            ...state,
            loading: true,
            deletedUser: null,
        };
    },

    [Types.DELETE_USER_SUCCESS]: (state, action) => {
        return {
            ...state,
            loading: false,
            deletedUser: true,
        };
    },

    [Types.DELETE_USER_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            deletedUser: null,
        };
    },

    // Fetch roles
    [Types.FETCH_ROLES]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.FETCH_ROLES_SUCCESS]: (state, {roles}) => {
        return {
            ...state,
            roles,
            loading: false,
        };
    },

    [Types.FETCH_ROLES_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },

    // Fetch a single user
    [Types.FETCH_PROFILE]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            user: null,
            userToEdit: null,
        };
    },

    [Types.FETCH_PROFILE_SUCCESS]: (state, {user}) => {
        return {
            ...state,
            loading: false,
            error: null,
            user,
        };
    },

    [Types.FETCH_PROFILE_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            user: null,
        };
    },

        // Update profile
    [Types.UPDATE_PROFILE]: (state, action) => {
        return {
            ...state,
            loading : true,
            error: null,
            updateDeleteSuccess: null,
            userCreated: null,
        };
    },

    [Types.UPDATE_PROFILE_SUCCESS]: (state, {user}) => {
        return {
            ...state,
            loading: false,
            user,
            error: null,
            userCreated: user,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.UPDATE_PROFILE_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            user: null,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/UserRedux.js